<adapt-dialog [maxWidth]="1000">
    <h3 adapt-dialog-title>{{ title }}</h3>

    <div adapt-dialog-content>
        <h2>
            <adapt-link-person [personId]="person.personId"
                               [showImage]="true"></adapt-link-person>
        </h2>

        <adapt-cvt-history [personId]="person.personId"></adapt-cvt-history>
    </div>

    <div adapt-dialog-footer
         class="ms-auto">
        <button adaptButtonIcon="fal fa-download"
                (click)="exportGrid()">Export data</button>
        <button adaptButton="ok"
                (click)="cancel()"></button>
    </div>
</adapt-dialog>
